
  import { Component, Model, Prop, Vue, Watch } from 'vue-property-decorator';
  import PageFooter from '@/components/page-footer.vue';
  import Dialog from '@/components/dialog.vue';
  import {
    orderSettleoperateRecordlist
  } from "@/api/order"
  @Component({  
    name: '',
    components: {
      PageFooter,
      'slz-dialog': Dialog,
    }
  })

  export default class ProductList extends Vue {
    @Model('change') show:boolean
    @Prop({default:{}}) msg:any
    private diaShow = false
    private loading = false
    private linelist:any = []
    private active = 0

    @Watch('show')
    private init(val){
      this.diaShow = val
      if(val){
        this.getlist()
      }
    }
    private async getlist(){
      try{
        this.loading = true
        let res = await orderSettleoperateRecordlist({
          FinanceOrderSettleRecordId:this.msg.Id
        })
        if(res.IsSuccess){
          this.active = 0
          this.linelist = res.Result.map((v,i)=>{
            v.color = v.Id?'#409eff':'#606266'
            v.icon = v.Id?'el-icon-circle-check':''
            this.active = v.Id>0?i+1:this.active
            v.Remark = v.Remark.replace(/【【/g,'<span style="color:#f56c6c">').replace(/】】/g,'</span>')
            return v
          })
        }
      }finally{
        this.loading = false
      }
    }
    private close(){
      this.$emit('change',false)
    }
  }
